import SelectionControl from './component';

export default SelectionControl;
